export default __webpack_public_path__ + "static/media/about-1.d8bc3771.jpg";